import React from 'react';
import { Mail, Phone, ArrowRight } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-slate-900 text-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-31">
            Lassen Sie uns sprechen
          </h2>
          <p className="text-xl text-slate-300" data-id="element-32">
            Jedes Projekt beginnt mit einem guten Gespräch. Erzählen Sie uns von
            Ihren Herausforderungen.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-33">
          <div className="bg-slate-800 p-8 rounded-xl border border-slate-700" data-id="element-34">
            <div className="flex items-center mb-6" data-id="element-35">
              <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center mr-4" data-id="element-36">
                <Mail className="text-blue-400" size={24} data-id="element-37" />
              </div>
              <div data-id="element-38">
                <h3 className="text-lg font-semibold text-white" data-id="element-39">
                  Email schreiben
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-40">
                  Wir antworten innerhalb von 24h
                </p>
              </div>
            </div>
            <a href="mailto:info@ellnerconsult.de" className="text-2xl font-medium text-blue-400 hover:text-blue-300 transition-colors block mb-4" data-id="element-41">
              info@ellnerconsult.de
            </a>
            <p className="text-slate-400 text-sm" data-id="element-42">
              Für Anfragen zu Schulungen, Beratung oder Freelance-Unterstützung.
            </p>
          </div>

          <div className="bg-slate-800 p-8 rounded-xl border border-slate-700" data-id="element-43">
            <div className="flex items-center mb-6" data-id="element-44">
              <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center mr-4" data-id="element-45">
                <Phone className="text-blue-400" size={24} data-id="element-46" />
              </div>
              <div data-id="element-47">
                <h3 className="text-lg font-semibold text-white" data-id="element-48">
                  Rufen Sie uns an
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-49">
                  Kostenloses Erstgespräch
                </p>
              </div>
            </div>
            
            <p className="text-2xl font-medium text-blue-400 hover:text-blue-300 transition-colors block mb-4" data-id="element-50">
              +49 (0) 170 450 2536
            </p>
          </div>
        </div>
      </div>
    </section>;
}